import React from 'react';

import { HowDoYouWantToUse } from '../../components/Onboarding/HowDoYouWantToUse.component';

export const HowDoYouWantToUsePage: React.FC = () => {
  return <HowDoYouWantToUse />;
};
